/* eslint-disable react-hooks/exhaustive-deps */

import React from 'react';
import PropTypes from 'prop-types';
import Body from '@redturtle/iovisit-theme/components/Blocks/MultimediaFolderGallery/Body';

const View = (props) => {
  return <Body {...props} />;
};

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
